module.exports = __webpack_public_path__ + "img/collection-diamondJewelry.6645cfc.webp";